import FormField from "components/v2/FormField";
import { useFormikContext } from "formik";
import { BiTrash } from "react-icons/bi";
import { activeCurrencies, currencyDecimalPlaces, getActiveCurrencyCodeLabel } from "utils";
import useCurrencies from "api/CurrencyResource/useCurrencies";
import usePaymentMethodAvailability from "api/PaymentsResource/usePaymentMethodAvailability";
import { MAX_VOUCHER_QUANTITY } from "./voucherForm";

const VoucherEntryFields = ({ index, canRemove, onRemove, today }) => {
    const { data: currencies = [], isLoading: currenciesLoading, isError: currenciesError } = useCurrencies();
    const { data: methods, isLoading: methodsLoading, isError: methodsError } = usePaymentMethodAvailability();
    const currencyOptions = currencies.filter((currency) => methods?.Voucher?.supported_currencies?.includes(currency.code)).map((currency) => ({ label: `${currency.label} (${currency.code})`, value: currency.code }));
	const { values } = useFormikContext();
	const voucher = values.vouchers[index];
	const headingId = `voucher-entry-${index}-heading`;
	const currencyLabel = getActiveCurrencyCodeLabel(
		voucher?.currency || activeCurrencies.USD.code
	);

	return (
		<div
			role="group"
			aria-labelledby={headingId}
			className="flex items-start gap-3 pt-8 portal-voucher-entry-table"
		>
			<div className="w-8 flex-shrink-0 portal-voucher-entry-action">
				<span className="portal-field-label" aria-hidden="true">&nbsp;</span>
				<p id={headingId} className="text-sm font-semibold text-gray-500">{index + 1}</p>
			</div>

			<div className="w-36 flex-shrink-0">
				<FormField
					type="select"
					name={`vouchers.${index}.currency`}
					label="Currency *"
					options={currencyOptions}
                    disabled={currenciesLoading || methodsLoading || currenciesError || methodsError}
                    isLoading={currenciesLoading || methodsLoading}
					filter
					width="w-full"
				/>
                {(currenciesError || methodsError) && <p role="alert" className="text-xs text-red-700">Unable to load voucher currencies.</p>}
                {!currenciesLoading && !methodsLoading && !currenciesError && !methodsError && !currencyOptions.length && <p role="status" className="text-xs text-gray-600">Configure voucher currencies in Payment Methods.</p>}
			</div>

			<div className="w-40 flex-shrink-0">
				<FormField
					label={`Tokens * (${currencyLabel})`}
					name={`vouchers.${index}.number_of_tokens`}
					type="number"
					min="1"
                    step={10 ** -currencyDecimalPlaces(voucher?.currency)}
					width="w-full"
				/>
			</div>

			<div className="w-40 flex-shrink-0">
				<FormField
					label="Expiry *"
					name={`vouchers.${index}.expiry_date`}
					type="date"
					min={today}
					width="w-full"
				/>
			</div>

			<div className="w-28 flex-shrink-0">
				<FormField
					label="Qty *"
					name={`vouchers.${index}.quantity`}
					type="number"
					min="1"
					max={MAX_VOUCHER_QUANTITY}
					width="w-full"
				/>
			</div>

			<div className="portal-voucher-entry-currency flex-1">
				<FormField
					label={`Label (e.g HLF ${today})`}
					name={`vouchers.${index}.tag`}
					width="w-full"
				/>
			</div>

			<div className="w-28 flex-shrink-0 portal-voucher-entry-toggle">
				<label className="portal-field-label" htmlFor={`vouchers.${index}.is_hlf`}>HLF</label>
				<div>
				<FormField
					type="switcher"
					name={`vouchers.${index}.is_hlf`}
				/>
				</div>
			</div>

			<div className="w-10 flex-shrink-0 portal-voucher-entry-action">
				<span className="portal-field-label" aria-hidden="true">&nbsp;</span>
				{canRemove && (
					<button
						type="button"
						onClick={onRemove}
						aria-label={`Remove voucher ${index + 1}`}
						className="portal-icon-button text-red-700 hover:bg-red-50"
					>
						<BiTrash size={18} aria-hidden="true" />
					</button>
				)}
			</div>
		</div>
	);
};

export default VoucherEntryFields;
